export { SortationCode as GSSortationCode } from './SortationCode';
